import React from 'react';
import { CtaButton } from './CtaButton';
import { Emoji } from './Emoji';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/1LVXHPovWovWFnFGiRKCeA/Diseno_sin_titulo.png';
const chips = [{
  emoji: '✅',
  label: '100% PDF'
}, {
  emoji: '⚡',
  label: 'Acceso en 5 min'
}, {
  emoji: '🕐',
  label: '2 hs de cocina'
}];
const trust = [{
  emoji: '🛡️',
  label: 'Garantía 7 días'
}, {
  emoji: '🔒',
  label: 'Pago seguro'
}, {
  emoji: '💳',
  label: 'Mercado Pago'
}];
export function Hero() {
  return <header className="w-full bg-white" data-id="element-121" data-mp="xbflbcukdj6p">
      <div className="mx-auto flex w-full max-w-[760px] flex-col items-center px-4 pb-8 pt-4 text-center sm:px-6 sm:pt-6 lg:max-w-[860px] lg:pb-12" data-id="element-122" data-mp="x8b7dnrar92u">
        <span className="inline-flex items-center gap-2 font-display text-[10px] font-extrabold uppercase tracking-[0.24em] text-ink-900 sm:text-sm" data-id="element-123" data-mp="nczqozwbvrsg">
          <Emoji symbol="🍽️" data-id="element-124" data-mp="3czflm08u696k" />
          Close The Gap<span className="text-celeste-600" data-id="element-125" data-mp="3825yir8x69lw">™</span>
        </span>

        <h1 className="mt-3 font-display text-[clamp(1.6rem,7.5vw,3.5rem)] font-black leading-[1.05] tracking-tight text-ink-900 sm:mt-5" data-id="element-126" data-mp="3j8ixl0k6uiv8">
          +300 recetas proteicas.
          <span className="mt-1 block text-celeste-600" data-id="element-127" data-mp="3o6u697yqynbv">Listas desde hoy.</span>
        </h1>

        <img src={PRODUCT_IMAGE} alt="MegaPack Cocina Proteica Lista: 6 tomos y 6 bonos en PDF con recetas, viandas y planificadores" className="mt-3 block h-auto max-h-[34vh] w-full max-w-[420px] object-contain sm:mt-5 sm:max-h-none sm:max-w-[560px]" width={560} height={560} data-id="element-128" data-mp="39a35ovdc75ko" />

        <p className="mt-3 font-display text-[13px] font-bold leading-snug tracking-tight text-celeste-700 sm:mt-5 sm:text-lg" data-id="element-129" data-mp="2qk3lalsfyenl">
          El sistema de alimentación proteica N°1 para ganancia muscular y
          pérdida de peso
        </p>

        <ul className="mt-3 flex w-full flex-wrap items-center justify-center gap-1.5 sm:mt-5 sm:gap-2" data-id="element-130" data-mp="2hkgipwnz72sy">
          {chips.map(chip => <li key={chip.label} className="inline-flex items-center gap-1.5 rounded-full border border-line bg-celeste-100 px-2.5 py-1 text-[11px] font-semibold text-ink-700 sm:px-3.5 sm:py-2 sm:text-sm" data-id="element-131" data-mp="2lml8gkbazfab">
              <Emoji symbol={chip.emoji} data-id="element-132" data-mp="id9t2bg2o7sr" />
              {chip.label}
            </li>)}
        </ul>

        <div className="mt-4 w-full max-w-md sm:mt-5" data-id="element-133" data-mp="degd8cdbc4pf">
          <CtaButton emoji="🥩" className="w-full" data-id="element-134" data-mp="1b0nkju104b5h">
            Quiero mi MegaPack ahora
          </CtaButton>
        </div>

        <ul className="mt-3 flex w-full flex-wrap items-center justify-center gap-x-4 gap-y-1.5 sm:mt-5 sm:gap-x-5 sm:gap-y-2" data-id="element-135" data-mp="161j7utevbvae">
          {trust.map(item => <li key={item.label} className="inline-flex items-center gap-1.5 text-[11px] text-ink-500 sm:text-sm" data-id="element-136" data-mp="x14mju1wmg6w">
              <Emoji symbol={item.emoji} data-id="element-137" data-mp="3luiawvasv7nh" />
              {item.label}
            </li>)}
        </ul>

        <p className="mt-6 max-w-xl text-[14px] leading-relaxed text-ink-500 sm:text-base" data-id="element-138" data-mp="3hq26kygu48ad">
          Recetas proteicas + listas de compras + planificadores + viandas
          listas para llevar. Sin improvisar. A un costo súper accesible. Sin
          dietas estrictas.
        </p>
      </div>
    </header>;
}